import { createSelector } from 'reselect'

const getFetchSchoolTeamRequest = state =>
  state.SchoolTeam.fetchSchoolTeamRequest

const getSchoolTeamId = state => state.SchoolTeam.team.schoolId

const isSchoolAPobbleSchool = state => state.SchoolTeam.team.pobble_school
const getSchoolTeam = state => state.SchoolTeam.team
const getNormalizedTeachers = state => state.SchoolTeam.team.teachers

const getTeachersResult = createSelector(
  [getNormalizedTeachers],
  teachers => (!teachers ? null : teachers.result)
)

const getTeachers = createSelector(
  [getNormalizedTeachers],
  teachers => (!teachers ? null : teachers.entities.teachers)
)

const getTeachersList = createSelector(
  [getTeachersResult, getTeachers],
  (result, teachers) => (!result ? null : result.map(id => teachers[id]))
)

const getTeacher = (state, id) => getTeachers(state)[id]

const getNormalizedPendingTeachers = state =>
  state.SchoolTeam.team.pending_teachers

const getPendingTeachersResult = createSelector(
  [getNormalizedPendingTeachers],
  pendingTeachers => (!pendingTeachers ? null : pendingTeachers.result)
)

const getPendingTeachers = createSelector(
  [getNormalizedPendingTeachers],
  pendingTeachers =>
    !pendingTeachers ? null : pendingTeachers.entities.pending_teachers
)

const getPendingTeachersList = createSelector(
  [getPendingTeachersResult, getPendingTeachers],
  (result, pendingTeachers) =>
    !result ? null : result.map(id => pendingTeachers[id])
)

const getPendingTeacher = (state, id) => getPendingTeachers(state)[id]

export {
  getFetchSchoolTeamRequest,
  getSchoolTeam,
  getTeachersList,
  getTeacher,
  getPendingTeachersList,
  getPendingTeacher,
  getSchoolTeamId,
  isSchoolAPobbleSchool
}
